(function () {
  'use strict';
  if (window.SambaCollection) { window.SambaCollection.mount(); return; }
  var mounted = new WeakMap(), products = new Map(), hour = 3600000;
  var timerKey = 'nortiv8:samba:anniversary:start:v1', memoryStart = Date.now();
  function visitorStart() {
    var now = Date.now(), start;
    try { start = Number(localStorage.getItem(timerKey)); } catch (_) {}
    if (!Number.isFinite(start) || start <= 0 || start > now) {
      start = Math.min(memoryStart, now);
      try { localStorage.setItem(timerKey, String(start)); } catch (_) {}
    }
    return start;
  }
  function node(tag, className, text) {
    var el = document.createElement(tag);
    if (className) el.className = className;
    if (text != null) el.textContent = text;
    return el;
  }
  function mount(root) {
    if (mounted.has(root)) return;
    var money, config = { country: root.dataset.country, currency: root.dataset.currency,
      single: Number(root.dataset.single), compare: Number(root.dataset.compare), double: Number(root.dataset.double), doubleCompare: Number(root.dataset.doubleCompare) };
    try { money = new Intl.NumberFormat('en-US', {style:'currency', currency:config.currency}); } catch (_) { return; }
    var format = function (cents) { return money.format(cents / 100); };
    root.querySelectorAll('[data-samba-money]').forEach(function (el) { el.textContent = format(Number(el.dataset.sambaMoney)); });
    var timer = root.querySelector('[data-samba-timer]'), started = visitorStart();
    function tick() {
      if (!timer) return;
      // Repeating campaign animation, independent of discount eligibility.
      var seconds = Math.ceil((hour - ((Math.max(0, Date.now() - started)) % hour)) / 1000);
      timer.textContent = [Math.floor(seconds / 3600), Math.floor(seconds % 3600 / 60), seconds % 60].map(function (n) { return String(n).padStart(2, '0'); }).join(' : ');
    }
    tick(); var interval = timer ? setInterval(tick, 1000) : null;
    function storage(event) { if (event.key === timerKey) { started = visitorStart(); tick(); } }
    window.addEventListener('storage', storage);
    var dialog = root.querySelector('dialog'), form = dialog.querySelector('form'), pairs = root.querySelector('[data-samba-pairs]');
    var status = root.querySelector('[data-samba-status]'), submit = form.querySelector('[type=submit]'), retry = root.querySelector('[data-samba-retry]');
    var selected, product, variants = [], selections = [], quantity = 2, opener, busy = false, generation = 0;
    function optionValue(variant, type) {
      var option = variant.selectedOptions.find(function (o) { return type === 'size' ? /^sizes?$/i.test(o.name) : /^(colors?|colours?)$/i.test(o.name); });
      return option ? option.value : '';
    }
    function matches(selection) { return variants.find(function (v) { return optionValue(v,'color') === selection.color && optionValue(v,'size') === selection.size; }); }
    function ready() { return product && selections.slice(0,quantity).every(function (s) { var v = matches(s); return v && v.availableForSale && v.price.currencyCode === config.currency; }); }
    function pickerTotals(qty) {
      if (!selected || selected.palette !== 'v2') return {total:qty===2?config.double:config.single,compare:qty===2?config.doubleCompare:config.compare};
      var values=[];
      for (var i=0;i<qty;i++) {
        var color=(selections[i] && selections[i].color) || selected.color;
        var button=Array.from(root.querySelectorAll('[data-samba-select]')).find(function (b) { var d=JSON.parse(b.dataset.product);return d.palette==='v2' && d.color===color; });
        values.push(button ? Number(JSON.parse(button.dataset.product).single) : Number(selected.single));
      }
      return window.SambaPaletteOffers.totals(values);
    }
    function updatePickerPrices() {
      [1,2].forEach(function (qty) {
        var card=form.querySelector('[data-samba-bundle-card="'+qty+'"]'), totals=pickerTotals(qty);
        if (!card || !totals) return;
        card.querySelector('.samba-bundle-price strong').textContent=format(totals.total);
        card.querySelector('.samba-bundle-price s').textContent=format(totals.compare);
        var sub=card.querySelector('.samba-bundle-copy small span');if(sub)sub.textContent=format(Math.round(totals.total/qty));
      });
    }
    function update() {
      updatePickerPrices();
      submit.disabled = busy || !ready();
      submit.textContent = busy ? 'Adding…' : 'Add to cart · ' + format(pickerTotals(quantity).total);
    }
    function colorImage(color) {
      var card = Array.from(root.querySelectorAll('[data-samba-select]')).find(function (button) { var data = JSON.parse(button.dataset.product); return data.color === color && data.productId === selected.productId; });
      return card ? JSON.parse(card.dataset.product).image : selected.image;
    }
    function drawSwatches() {
      var swatches = root.querySelector('[data-samba-swatches]'); swatches.replaceChildren();
      if(!selections.length) return;
      var order = window.SambaPaletteOffers.colors(selected.palette || 'original');
      var colors = Array.from(new Set(variants.map(function (v) { return optionValue(v,'color'); }))).filter(Boolean);
      colors.sort(function(a,b){return order.indexOf(a)-order.indexOf(b);});
      colors.forEach(function(color){
        var button=node('button','samba-color-swatch');button.type='button';
        button.setAttribute('aria-label',color);button.setAttribute('aria-pressed',String(selections[0].color===color));
        button.disabled=!variants.some(function(v){return optionValue(v,'color')===color && v.availableForSale && v.price.currencyCode===config.currency;});
        var img=node('img');img.src=colorImage(color);img.alt='';img.width=90;img.height=90;img.loading='lazy';
        button.append(img,node('span','',color));
        button.addEventListener('click',function(){selections.slice(0,quantity).forEach(function(selection){selection.color=color;var v=matches(selection);if(!v||!v.availableForSale)selection.size='';});status.textContent='';drawPairs();});
        swatches.append(button);
      });
    }
    // Presentation control only: choices dispatch the existing native select's change event.
    function closeColorMenus() {
      root.querySelectorAll('.samba-color-menu').forEach(function(menu){ menu.hidden=true; });
      root.querySelectorAll('.samba-color-trigger').forEach(function(button){ button.setAttribute('aria-expanded','false'); });
      root.querySelectorAll('.samba-color-control--custom').forEach(function(control){ control.classList.remove('is-open'); });
    }
    function buildColorControl(select, selection, index) {
      var control=node('div','samba-color-control samba-color-control--custom');
      var trigger=node('button','samba-color-trigger'); trigger.type='button';
      trigger.setAttribute('role','combobox'); trigger.setAttribute('aria-haspopup','listbox');
      trigger.setAttribute('aria-expanded','false'); trigger.setAttribute('aria-label','Pair '+(index+1)+' color, '+selection.color);
      var menuId=root.id+'-pair-'+index+'-colors'; trigger.setAttribute('aria-controls',menuId);
      var thumb=node('img'); thumb.src=colorImage(selection.color); thumb.alt=''; thumb.width=34;thumb.height=34;
      var arrow=node('span','samba-color-chevron','⌄');arrow.setAttribute('aria-hidden','true');
      trigger.append(thumb,node('span','samba-color-name',selection.color),arrow);
      var menu=node('div','samba-color-menu');menu.id=menuId;menu.hidden=true;
      menu.setAttribute('role','listbox');menu.setAttribute('aria-label','Pair '+(index+1)+' colors');
      Array.from(select.options).forEach(function(option){
        var choice=node('button','samba-color-option');choice.type='button';choice.tabIndex=-1;choice.disabled=option.disabled;
        choice.setAttribute('role','option');choice.setAttribute('aria-selected',String(option.value===selection.color));
        choice.dataset.value=option.value;
        var image=node('img');image.src=colorImage(option.value);image.alt='';image.width=34;image.height=34;image.loading='lazy';
        choice.append(image,node('span','samba-color-name',option.textContent));
        var check=node('span','samba-color-check',option.value===selection.color?'✓':'');check.setAttribute('aria-hidden','true');choice.append(check);
        choice.addEventListener('click',function(){select.value=option.value;closeColorMenus();select.dispatchEvent(new Event('change',{bubbles:true}));});
        menu.append(choice);
      });
      function openMenu(focusOption){
        closeColorMenus();menu.hidden=false;control.classList.add('is-open');trigger.setAttribute('aria-expanded','true');
        var rect=control.getBoundingClientRect(),bounds=dialog.getBoundingClientRect();
        var below=bounds.bottom-rect.bottom-12,above=rect.top-bounds.top-12;
        control.classList.toggle('is-above',below<menu.offsetHeight && above>below);
        if(focusOption){var active=menu.querySelector('[aria-selected="true"]:not(:disabled)')||menu.querySelector(':not(:disabled).samba-color-option');if(active)active.focus();}
      }
      trigger.addEventListener('click',function(){if(menu.hidden)openMenu(false);else closeColorMenus();});
      trigger.addEventListener('keydown',function(event){
        if(event.key==='ArrowDown'||event.key==='ArrowUp'){event.preventDefault();openMenu(true);}
        if(event.key==='Escape'&&!menu.hidden){event.preventDefault();event.stopPropagation();closeColorMenus();}
      });
      menu.addEventListener('keydown',function(event){
        var options=Array.from(menu.querySelectorAll('.samba-color-option:not(:disabled)')),current=options.indexOf(document.activeElement),next;
        if(event.key==='ArrowDown')next=(current+1)%options.length;
        if(event.key==='ArrowUp')next=(current-1+options.length)%options.length;
        if(event.key==='Home')next=0;
        if(event.key==='End')next=options.length-1;
        if(next!=null){event.preventDefault();options[next].focus();}
        if(event.key==='Escape'){event.preventDefault();event.stopPropagation();closeColorMenus();trigger.focus();}
        if(event.key==='Tab'){closeColorMenus();trigger.focus();}
      });
      control.addEventListener('focusout',function(event){if(!control.contains(event.relatedTarget))closeColorMenus();});
      select.hidden=true;select.tabIndex=-1;control.append(select,trigger,menu);
      return control;
    }
    root.addEventListener('pointerdown',function(event){if(!event.target.closest('.samba-color-control--custom'))closeColorMenus();});

    function drawPairs() {
      pairs.replaceChildren();
      root.querySelector('[data-samba-pair-host="'+quantity+'"]').append(pairs);
      drawSwatches();
      selections.slice(0,quantity).forEach(function (selection, index) {
        var field = node('fieldset','samba-pair'); field.append(node('legend','', 'Pair ' + (index + 1)));
        var fields = node('div','samba-pair__fields');
        ['size','color'].forEach(function (type) {
          var label = node('label','',type === 'color' ? 'Color' : 'Size (M / W)');
          var select = node('select'); select.required = true; select.dataset.pair = String(index); select.dataset.option = type;
          select.setAttribute('aria-label','Pair ' + (index + 1) + ' ' + type);
          var values = type === 'color' ? Array.from(new Set(variants.map(function (v) { return optionValue(v,'color'); }))) : Array.from(new Set(variants.filter(function (v) { return optionValue(v,'color') === selection.color; }).map(function (v) { return optionValue(v,'size'); })));
          if (type === 'size') { var placeholder = node('option','','Select size'); placeholder.value = ''; select.append(placeholder); }
          values.filter(Boolean).forEach(function (value) {
            var available = variants.some(function (v) { return v.availableForSale && v.price.currencyCode === config.currency && optionValue(v,type) === value && (type === 'color' || optionValue(v,'color') === selection.color); });
            var option = node('option','', value + (available ? '' : ' — unavailable')); option.value = value; option.disabled = !available; select.append(option);
          });
          select.value = selection[type];
          if(type==='color') label.append(buildColorControl(select,selection,index)); else label.append(select);
          fields.append(label);
          select.addEventListener('change',function () {
            selection[type] = select.value;
            if (type === 'color') {
              var variant = matches(selection); if (!variant || !variant.availableForSale) selection.size = '';
              drawPairs(); pairs.querySelector('[data-pair="' + index + '"][data-option="size"]').focus();
            }
            status.textContent = ''; update();
          });
        });
        field.append(fields); pairs.append(field);
      }); update();
    }
    async function load() {
      var requestId = ++generation;
      product = null; variants = []; pairs.replaceChildren(); status.textContent = 'Loading colors and sizes…'; retry.hidden = true; update();
      try {
        if (!window.SentinelCart) throw Error('The cart is still loading. Please try again.');
        if (![config.single,config.compare,config.double,config.doubleCompare].every(function (n) { return Number.isSafeInteger(n) && n > 0; })) throw Error('This offer is not configured yet. Please visit the product page.');
        var key = selected.productId + ':' + config.country;
        var entry = products.get(key);
        if (!entry || Date.now() - entry.at > 60000) {
          entry = {at:Date.now(), promise:window.SentinelCart.getProduct(selected.productId,config.country)}; products.set(key,entry);
          entry.promise.catch(function () { if (products.get(key) === entry) products.delete(key); });
        }
        var loaded = await entry.promise;
        if (requestId !== generation || !dialog.open) return;
        loaded = window.SambaPaletteOffers.product(loaded, selected.palette || 'original', selected.color);
        variants = loaded.variants.edges.map(function (e) { return e.node; });
        if (!variants.some(function (v) { return optionValue(v,'color') === selected.color && v.availableForSale && v.price.currencyCode === config.currency; })) throw Error('This color is currently unavailable. Please choose another color.');
        if (!variants.every(function (v) { return optionValue(v,'color') && optionValue(v,'size'); })) throw Error('This product requires a different selection. Please visit its product page.');
        product = loaded;
        selections = [{color:selected.color,size:''},{color:selected.color,size:''}];
        status.textContent = ''; drawPairs();
      } catch (err) {
        if (requestId !== generation || !dialog.open) return;
        product = null; status.textContent = err.message; retry.hidden = false; update();
      }
    }
    function close() { if (busy) return; generation++; dialog.close(); }
    root.querySelector('[data-samba-close]').addEventListener('click',close);
    dialog.addEventListener('cancel',function (event) { if (busy) event.preventDefault(); else generation++; });
    dialog.addEventListener('close',function () { if (opener && !busy) opener.focus(); document.documentElement.classList.remove('samba-picker-open'); });
    root.querySelectorAll('[data-samba-select]').forEach(function (button) {
      button.addEventListener('click',function () {
        if (busy) return;
        selected = JSON.parse(button.dataset.product); opener = button; quantity = 2;
        form.querySelector('[type=radio][value="2"]').checked = true;
        root.querySelector('[data-samba-picker-color]').textContent=selected.color; document.documentElement.classList.add('samba-picker-open'); dialog.showModal(); load();
      });
    });
    form.querySelectorAll('[type=radio]').forEach(function (radio) { radio.addEventListener('change',function () { quantity = Number(radio.value); drawPairs(); }); });
    retry.addEventListener('click',load);
    form.addEventListener('submit',async function (event) {
      event.preventDefault(); if (busy || !ready()) return;
      busy = true; update(); status.textContent = '';
      var lines = selections.slice(0,quantity).map(function (selection) { var variant = matches(selection); return {variantId:variant.id, quantity:1, label:selection.color + ' / ' + selection.size, unitCents:Math.round(Number(variant.price.amount)*100)}; });
      var offer = {key:selected.productId + (selected.palette==='v2'?':v2':'') + ':samba-' + quantity + '-pairs', productId:selected.productId,title:selected.title,
        bundle:quantity === 2 ? '2 pairs · 50% off second pair' : '1 pair',country:config.country,currency:config.currency,
        displayedCents:pickerTotals(quantity).total,compareCents:pickerTotals(quantity).compare,
        image:colorImage(selections[0].color),url:selected.url,lines:lines};
      // A single call owns persistence, drawer opening and tracking. No duplicate pixel events here.
      dialog.close();
      try { await window.SentinelCart.purchase(offer,'cart'); }
      catch (err) { if (root.isConnected) { dialog.showModal(); status.textContent = err.message; } }
      finally { busy = false; update(); }
    });
    var cards=Array.from(root.querySelectorAll('.samba-card')), grid=root.querySelector('.samba-grid');
    function filterCards(){
      var colors=Array.from(root.querySelectorAll('[data-samba-filter-color]:checked')).map(function(el){return el.value;});
      var stock=root.querySelector('[data-samba-filter-stock]').checked;
      var visible=0;cards.forEach(function(card){card.hidden=(colors.length>0 && !colors.includes(card.dataset.color)) || (stock && card.dataset.available!=='true');if(!card.hidden)visible++;});
      root.querySelector('[data-samba-count]').textContent=visible+' '+(visible===1?'color':'colors');
      root.querySelector('[data-samba-filter-count]').textContent=colors.length+Number(stock)>0?'('+ (colors.length+Number(stock)) +')':'';
      root.querySelector('[data-samba-empty]').hidden=visible>0;
    }
    root.querySelectorAll('[data-samba-filter-color],[data-samba-filter-stock]').forEach(function(input){input.addEventListener('change',filterCards);});
    root.querySelector('[data-samba-filter-clear]').addEventListener('click',function(){root.querySelectorAll('.samba-filters input').forEach(function(input){input.checked=false;});filterCards();});
    root.querySelector('[data-samba-sort]').addEventListener('change',function(event){var value=event.target.value;var sorted=cards.slice();if(value==='az'||value==='za')sorted.sort(function(a,b){return a.dataset.color.localeCompare(b.dataset.color)*(value==='za'?-1:1);});if(value.indexOf('price-')===0)sorted.sort(function(a,b){return (Number(a.dataset.price)-Number(b.dataset.price))*(value==='price-desc'?-1:1);});sorted.forEach(function(card){grid.append(card);});});
    var guide=root.querySelector('.samba-size-guide');
    dialog.addEventListener('toggle',function(){document.documentElement.classList.toggle('samba-picker-open',dialog.open);});
    root.querySelector('[data-samba-guide-open]').addEventListener('click',function(){guide.showModal();});
    root.querySelector('[data-samba-guide-close]').addEventListener('click',function(){guide.close();});
    [dialog,guide].forEach(function(modal){modal.addEventListener('click',function(event){if(event.target!==modal)return;var rect=modal.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom){if(modal===dialog)close();else guide.close();}});});
    root.querySelector('[data-samba-per-pair]').textContent=format(config.double/2);
    mounted.set(root,function () { clearInterval(interval); window.removeEventListener('storage',storage); generation++; dialog.close(); });
  }
  function mountAll() { document.querySelectorAll('[data-samba-collection]').forEach(mount); }
  window.SambaCollection = Object.freeze({mount:mountAll});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',mountAll); else mountAll();
  document.addEventListener('shopify:section:load',mountAll);
  document.addEventListener('shopify:section:unload',function (event) { event.target.querySelectorAll('[data-samba-collection]').forEach(function (root) { var dispose = mounted.get(root); if (dispose) dispose(); mounted.delete(root); }); });
})();
